import React from 'react';

export const SubmenuStateContext = React.createContext({
  isCollapsed: false,
});
